import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { createContext, useReducer, useEffect } from "react";
export const WebhooksValue = createContext(null);
export const WebhooksDisbatch = createContext(null);
const reducer = (state, action) => {
  const newState = { ...state };
  if (action.type === "set") {
    return action.value;
  }

  return newState;
};

export default function WebhooksContext({ children }) {
  const [state, dispatch] = useReducer(reducer, []);
  const { appId, pageId } = useParams();

  useEffect(() => {
    if (appId && pageId) {
      db.collection("apps")
        .doc(appId)
        .collection("webhooks")
        .orderBy("name")
        .onSnapshot((snap) => {
          const _webhooks = snap.docs.map((doc) => {
            return { ...doc.data(), id: doc.id };
          });
          dispatch({ type: "set", value: _webhooks });
        });
    }
  }, [appId, pageId]);

  return (
    <WebhooksValue.Provider value={state}>
      <WebhooksDisbatch.Provider value={dispatch}>
        {children}
      </WebhooksDisbatch.Provider>
    </WebhooksValue.Provider>
  );
}
